import { render } from "./ContextMenuItem.vue?vue&type=template&id=254b8a72&scoped=true"
import script from "./ContextMenuItem.vue?vue&type=script&lang=js"
export * from "./ContextMenuItem.vue?vue&type=script&lang=js"

import "./ContextMenuItem.vue?vue&type=style&index=0&id=254b8a72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254b8a72"]])

export default __exports__